module.exports = __webpack_public_path__ + "img/helm.0d1950ff.png";